const n = {
  height: "44px",
  borderRadius: "8px",
  border: "1px solid var(--primary-600)",
  padding: "10px 18px",
  iconSize: "20px",
  iconMargin: "8px"
}, t = {
  height: "40px",
  borderRadius: "8px",
  padding: "10px 16px",
  border: "1px solid var(--primary-600)",
  iconSize: "20px",
  iconMargin: "8px"
}, d = {
  height: "36px",
  borderRadius: "8px",
  padding: "8px 14px",
  border: "1px solid var(--primary-600)",
  iconSize: "20px",
  iconMargin: "8px"
}, r = {
  height: "32px",
  borderRadius: "4px",
  padding: "6px 10px",
  border: "1px solid var(--primary-600)",
  iconSize: "16px",
  iconMargin: "8px"
}, x = {
  height: "28px",
  borderRadius: "4px",
  padding: "8px",
  border: "1px solid var(--primary-600)",
  iconSize: "16px",
  iconMargin: "6px"
}, o = {
  height: "24px",
  borderRadius: "4px",
  padding: "8px 6px",
  border: "1px solid var(--primary-600)",
  iconSize: "14px",
  iconMargin: "4px"
}, s = {
  padding: "initial",
  borderRadius: "4px",
  height: "initial"
}, a = (i = "md") => ({
  ...{
    lg: n,
    md: t,
    sm: d,
    xs: r,
    "2xs": x,
    "3xs": o
  }[i],
  boxShadow: "0px 1px 2px 0px #1018280D"
}), e = () => s, g = (i = "md") => ({
  lg: { padding: "12px" },
  md: { padding: "10px" },
  sm: { padding: "8px" },
  xs: { padding: "8px" },
  "2xs": { padding: "6px" },
  "3xs": { padding: "5px" }
})[i] || {};
export {
  a as getButtonSizeStyles,
  g as getIconOnlyButtonPaddings,
  e as getLinkButtonSize
};
